import React from "react";
import { SelectedProjects } from "./data/SelectedProjects";
import ProjectsItem from "../projects-page/ProjectsItem";

export default function ProjectsSection() {
  const projectKeys = Object.keys(SelectedProjects);

  return (
    <div className="projects" id="projects">
      <div className="projects__title">
        <h3>Selected Projects</h3>
        <div className="line-detail"></div>
      </div>
      <div className="projects__grid">
        {projectKeys.map((id) => {
          return (
            <ProjectsItem
              key={id}
              id={id}
              title={SelectedProjects[id].title}
              image={SelectedProjects[id].image}
            />
          );
        })}
      </div>
      <div className="projects__link">
        <a href="/projects" className="projects-link">
          View all projects
        </a>
        <div className="projects-line-detail"></div>
      </div>
    </div>
  );
}
